/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="17.73"
        viewBox="0 0 19 17.73"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M19 0H0v14.31h9.06v2.42H5.28v1h8.56v-1h-3.78v-2.42H19Zm-1 13.31H1V1h17ZM16.38 2.57H2.65v8.75h13.73Zm-1 7.75H3.65V3.57h11.73Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ComputerMonitorIcon';

export default Icon;
